import React from 'react';
import Icon from '../../../Components/Icons/Icon';

const StepShell = ({title, intro, children}) => {
    return <div>
        <h1 className="text-xl font-bold mb-1">{title}</h1>
        {intro && <div className="text-sm text-muted mb-4">{intro}</div>}

        {children}
    </div>;
};

// The wizard's primary action: "Next" with an arrow, shared by every step
// that isn't the final account step
export const nextSubmit = {
    label: <span className="flex items-center gap-x-2">Next <Icon icon="ArrowRight" /></span>,
};

export default StepShell;
